import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface DefaultParameterOrderList {
  id: number
  systemUserId: number
  defaultType: string
  serial: number
  searchType: SystemCode
  configBranchCode: SystemCode
  traderEnvVendorId: number
  donorEnvVendorId: number
  buyDepartmentCode: SystemCode
  budgetYear: string
  budgetBranchCode: SystemCode
  budgetDepartmentCode: SystemCode
  budgetExpenseCode: SystemCode
  collectionType: SystemCode
  handlingType: SystemCode
  acceptType: SystemCode
  shelfType: SystemCode
  equipType: SystemCode
  selectReason: SystemCode
  defaultFlag: boolean
  orderNumbers: {
    orderBranchCode: SystemCode
    orderNumber: number
  }[]
  revision: number
}

export const defaultDefaultParameterOrderList = (): DefaultParameterOrderList => ({
  id: 0,
  systemUserId: 0,
  defaultType: '',
  serial: 0,
  searchType: defaultSystemCode(),
  configBranchCode: defaultSystemCode(),
  traderEnvVendorId: 0,
  donorEnvVendorId: 0,
  buyDepartmentCode: defaultSystemCode(),
  budgetYear: '',
  budgetBranchCode: defaultSystemCode(),
  budgetDepartmentCode: defaultSystemCode(),
  budgetExpenseCode: defaultSystemCode(),
  collectionType: defaultSystemCode(),
  handlingType: defaultSystemCode(),
  acceptType: defaultSystemCode(),
  shelfType: defaultSystemCode(),
  equipType: defaultSystemCode(),
  selectReason: defaultSystemCode(),
  defaultFlag: false,
  orderNumbers: [],
  revision: 0
})

export function DefaultParameterOrderListFromJSON(
  json: any
): DefaultParameterOrderList {
  return {
    id: exists(json, 'id') ? json.id : 0,
    systemUserId: exists(json, 'system_user_id') ? json.system_user_id : 0,
    defaultType: exists(json, 'default_type') ? json.default_type : '',
    serial: exists(json, 'serial') ? json.serial : 0,
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    configBranchCode: exists(json, 'config_branch_code')
      ? SystemCodeFromJSON(json.config_branch_code)
      : defaultSystemCode(),
    traderEnvVendorId: exists(json, 'trader_env_vendor_id')
      ? json.trader_env_vendor_id
      : 0,
    donorEnvVendorId: exists(json, 'donor_env_vendor_id')
      ? json.donor_env_vendor_id
      : 0,
    buyDepartmentCode: exists(json, 'buy_department_code')
      ? SystemCodeFromJSON(json.buy_department_code)
      : defaultSystemCode(),
    budgetYear: exists(json, 'budget_year') ? json.budget_year : '',
    budgetBranchCode: exists(json, 'budget_branch_code')
      ? SystemCodeFromJSON(json.budget_branch_code)
      : defaultSystemCode(),
    budgetDepartmentCode: exists(json, 'budget_department_code')
      ? SystemCodeFromJSON(json.budget_department_code)
      : defaultSystemCode(),
    budgetExpenseCode: exists(json, 'budget_expense_code')
      ? SystemCodeFromJSON(json.budget_expense_code)
      : defaultSystemCode(),
    collectionType: exists(json, 'collection_type')
      ? SystemCodeFromJSON(json.collection_type)
      : defaultSystemCode(),
    handlingType: exists(json, 'handling_type')
      ? SystemCodeFromJSON(json.handling_type)
      : defaultSystemCode(),
    acceptType: exists(json, 'accept_type')
      ? SystemCodeFromJSON(json.accept_type)
      : defaultSystemCode(),
    shelfType: exists(json, 'shelf_type')
      ? SystemCodeFromJSON(json.shelf_type)
      : defaultSystemCode(),
    equipType: exists(json, 'equip_type')
      ? SystemCodeFromJSON(json.equip_type)
      : defaultSystemCode(),
    selectReason: exists(json, 'select_reason')
      ? SystemCodeFromJSON(json.select_reason)
      : defaultSystemCode(),
    defaultFlag: exists(json, 'default_flag') ? json.default_flag : false,
    orderNumbers: exists(json, 'order_numbers')
      ? json.order_numbers.map((value: any) => {
          return {
            orderBranchCode: exists(value, 'order_branch_code')
              ? SystemCodeFromJSON(value.order_branch_code)
              : defaultSystemCode(),
            orderNumber: exists(value, 'order_number') ? value.order_number : 0
          }
        })
      : [],
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
